import {
  DeleteOutlined,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import {
  Button,
  Checkbox,
  CheckboxProps,
  GetProp,
  Input,
  message,
  Modal,
  Select,
  Upload,
  UploadProps,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { useEffect, useState } from "react";

type Props = {
  open?: any;
  isCloseModal?: any;
  user?: any;
};

type FileType = Parameters<GetProp<UploadProps, "beforeUpload">>[0];

const getBase64 = (img: FileType, callback: (url: string) => void) => {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result as string));
  reader.readAsDataURL(img);
};

const beforeUpload = (file: FileType) => {
  const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  if (!isJpgOrPng) {
    message.error("You can only upload JPG/PNG file!");
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error("Image must smaller than 2MB!");
  }
  return isJpgOrPng && isLt2M;
};

const ExpertModal: React.FC<Props> = ({ open, isCloseModal, user }: Props) => {
  const [name, setName] = useState<string>("");
  const [job, setJob] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState<string>();

  const handleChange: UploadProps["onChange"] = (info: any) => {
    if (info.file.status === "uploading") {
      setLoading(true);
      return;
    }
    if (info.file.status === "done") {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj as any, (url) => {
        setLoading(false);
        setImageUrl(url);
      });
    }
  };

  const uploadButton = (
    <button style={{ border: 0, background: "none" }} type="button">
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Загрузить фото</div>
    </button>
  );

  useEffect(() => {
    if (user.title) {
      setName(user?.title ? user?.title : "");
      setJob(user?.trusted ? user?.trusted : "");
    } else {
      setName("");
      setJob("");
    }
  }, [user]);

  const handleInputName = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    setName(event.target.value);
  };

  const handleInputJob = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setJob(event.target.value);
  };

  const handleInputDesc = (event: any): void => {
    setDescription(event.target.value);
  };

  const closeModal = (isOpen: boolean) => {
    isCloseModal();
  };

  const onChange: CheckboxProps["onChange"] = (e) => {
    console.log(`checked = ${e.target.checked}`);
  };

  return (
    <Modal
      title={`${!user ? "Добавить" : "Редактировать"} сотрудника`}
      open={open}
      onCancel={() => closeModal(false)}
      footer={
        user?.title
          ? [
              <Button key="cancel" onClick={() => closeModal(false)}>
                Отмена
              </Button>,
              <Button
                key="link"
                type="primary"
                onClick={() => closeModal(false)}
              >
                <DeleteOutlined />
                Удалить
              </Button>,
              <Button
                key="link"
                type="primary"
                onClick={() => closeModal(false)}
              >
                Сохранить
              </Button>,
            ]
          : [
              <Button key="cancel" onClick={() => closeModal(false)}>
                Отмена
              </Button>,
              <Button
                key="link"
                type="primary"
                onClick={() => closeModal(false)}
              >
                Сохранить
              </Button>,
            ]
      }
    >
      <Upload
        name="avatar"
        listType="picture-circle"
        className="avatar-uploader"
        showUploadList={false}
        action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
        beforeUpload={beforeUpload}
        onChange={handleChange}
      >
        {imageUrl ? (
          <img src={imageUrl} alt="avatar" style={{ width: "100%" }} />
        ) : (
          uploadButton
        )}
      </Upload>
      <p>ФИО сотрудника</p>
      <Input
        type="text"
        placeholder="Введите ФИО сотрудника полностью"
        value={name}
        name="name"
        onChange={handleInputName}
      />
      <p>Образование сотрудника</p>
      <Input
        type="text"
        placeholder="Введите образование сотрудника"
        value={job}
        name="job"
        onChange={handleInputJob}
      />
      <p>Кейсы</p>
      <TextArea
        placeholder="Введите описание"
        value={description}
        name="description"
        rows={4}
        onChange={handleInputDesc}
      />
      {!user && (
        <>
          <p>Выберите отдел</p>
          <div className="flex">
            <Select
              style={{ width: 200 }}
              allowClear={false}
              options={[
                { value: "Руководство" },
                { value: "Отдел маркетинга" },
                { value: "Отдел ИТ" },
                { value: "Бухгалтерия" },
                { value: "Склад" },
              ]}
              placeholder="Отдел сотрудника"
              showSearch
            />
            <Checkbox onChange={onChange}>
              Является руководителем отдела
            </Checkbox>
          </div>
        </>
      )}
    </Modal>
  );
};

export default ExpertModal;
